import { TemaCard } from 'src/data/models/TemaCardModel';

export const bankingCards: TemaCard[] = [
    // 🏦 Opening and managing a bank account
    new TemaCard(
        'bank1',
        'Banking',
        'sentence',
        'Quiero abrir una cuenta bancaria.',
        'I want to open a bank account.',
        'Use this when visiting a bank for the first time.'
    ),

    new TemaCard(
        'bank2',
        'Banking',
        'sentence',
        '¿Qué documentos necesito para abrir una cuenta?',
        'What documents do I need to open an account?',
        'Clarifies requirements like ID or proof of address.'
    ),

    new TemaCard(
        'bank3',
        'Banking',
        'phrase',
        '¿Puedo abrir una cuenta como extranjero?',
        'Can I open an account as a foreigner?',
        'Important for international visitors or expats.'
    ),

    // 🪪 Identity and verification
    new TemaCard(
        'bank4',
        'Banking',
        'phrase',
        'Necesito su identificación oficial.',
        'I need your official ID.',
        'What the clerk may ask during the process.'
    ),

    new TemaCard(
        'bank5',
        'Banking',
        'phrase',
        'Aquí tiene mi pasaporte y comprobante de domicilio.',
        'Here is my passport and proof of address.',
        'Response when asked for documents.'
    ),

    // 💳 Cards and ATM use
    new TemaCard(
        'bank6',
        'Banking',
        'word',
        'tarjeta',
        'card',
        'Common terms around banking cards.',
        [
            { spanish: 'tarjeta de débito', english: 'debit card' },
            { spanish: 'tarjeta de crédito', english: 'credit card' },
            { spanish: 'tarjeta virtual', english: 'virtual card' },
            { spanish: 'PIN', english: 'PIN' },
            { spanish: 'bloquear tarjeta', english: 'block card' },
        ]
    ),

    new TemaCard(
        'bank7',
        'Banking',
        'sentence',
        'Mi tarjeta fue rechazada.',
        'My card was declined.',
        'Essential if your payment fails.'
    ),

    new TemaCard(
        'bank8',
        'Banking',
        'phrase',
        '¿Dónde está el cajero automático más cercano?',
        'Where is the nearest ATM?',
        'Use this if you need to withdraw cash.'
    ),

    // 💸 Transfers, deposits, and withdrawals
    new TemaCard(
        'bank9',
        'Banking',
        'phrase',
        'Quiero hacer una transferencia.',
        'I want to make a transfer.',
        'Useful for sending funds.'
    ),

    new TemaCard(
        'bank10',
        'Banking',
        'sentence',
        '¿Cuánto es la comisión por esta transacción?',
        'How much is the fee for this transaction?',
        'Avoid surprise charges.'
    ),

    new TemaCard(
        'bank11',
        'Banking',
        'phrase',
        'Necesito depositar dinero en efectivo.',
        'I need to deposit cash.',
        'Basic task when funding your account.'
    ),

    new TemaCard(
        'bank12',
        'Banking',
        'phrase',
        'Quisiera retirar cien euros, por favor.',
        'I’d like to withdraw one hundred euros, please.',
        'When speaking to a teller.'
    ),

    // 📱 Online & mobile banking
    new TemaCard(
        'bank13',
        'Banking',
        'sentence',
        'No puedo acceder a mi cuenta en línea.',
        'I can’t access my online account.',
        'Use when facing login issues.'
    ),

    new TemaCard(
        'bank14',
        'Banking',
        'sentence',
        'Olvidé mi contraseña del banco.',
        'I forgot my bank password.',
        'Applies to both mobile and web.'
    ),

    new TemaCard(
        'bank15',
        'Banking',
        'word',
        'seguridad',
        'security',
        'Terms related to digital banking.',
        [
            { spanish: 'clave/PIN', english: 'password / PIN' },
            { spanish: 'verificación', english: 'verification' },
            { spanish: 'autenticación', english: 'authentication' },
            { spanish: 'doble factor', english: 'two-factor' },
            { spanish: 'token', english: 'token' },
        ]
    ),

    // 🤝 Customer service & account issues
    new TemaCard(
        'bank16',
        'Banking',
        'sentence',
        'Quisiera hablar con un asesor financiero.',
        'I’d like to speak with a financial advisor.',
        'Request for help or advice.'
    ),

    new TemaCard(
        'bank17',
        'Banking',
        'sentence',
        '¿Puedo cambiar mi dirección registrada?',
        'Can I change my registered address?',
        'To update your personal info.'
    ),

    new TemaCard(
        'bank18',
        'Banking',
        'phrase',
        'Gracias por su ayuda.',
        'Thank you for your help.',
        'Polite way to end an interaction.'
    ),
];
